import { FEATURE_TOGGLE_VMS_ONBOARDING_MANAGEMENT } from 'config/featureToggles'
import { IBusinessEntity } from 'models/BusinessEntity'

/**
 * Checks whether "Auto-Accept by Onboarded" setting is available for a business
 * @param businessEntity
 * @returns boolean
 */
export const autoAcceptByOnboardedSettingAccessCheck = (businessEntity: IBusinessEntity) => {
  const vmsOnboardingTrackingEnabled =
    businessEntity.vendor_management_system?.onboarding_tracking_enabled ?? false
  return FEATURE_TOGGLE_VMS_ONBOARDING_MANAGEMENT && vmsOnboardingTrackingEnabled
}

/**
 * Checks whether "Auto-Accept by Onboarded" setting is enabled for a business
 * @param businessEntity
 * @returns boolean
 */
export const hasBusinessAAbyOnboardedSettingEnabled = (businessEntity: IBusinessEntity) => {
  return FEATURE_TOGGLE_VMS_ONBOARDING_MANAGEMENT && businessEntity.auto_accept_by_onboarded
}

/**
 * Checks whether Selective Claim Mode (Selective Auto Accept) is enabled for a business.
 * We consider Selective Claim Mode enabled for a business, when one of the following settings are enabled for a business:
 * "Auto-Accept By Favorited", "Auto-Accept by Worked before", "Auto-Accept by Certificates", "Auto-Accept by Onboarded"
 * @param busienssEntity
 * @returns boolean
 */
export const hasBusinessSelectiveClaimModeEnabled = (businessEntity: IBusinessEntity) => {
  return (
    businessEntity.auto_accept_by_favored ||
    businessEntity.auto_accept_by_worked_before ||
    businessEntity.auto_accept_by_certificates ||
    hasBusinessAAbyOnboardedSettingEnabled(businessEntity)
  )
}

/**
 * Helper for checking whether the business entity can edit in_app_payments setting or not
 * @param {IBusinessEntity} businessEntity
 * @returns {Boolean}
 */
export const canEditInAppPaymentsSetting = (businessEntity: IBusinessEntity): boolean => {
  // if business has parent, the business can edit in_app_payments setting only when in_app_payments setting is enabled by the parent
  if (businessEntity.parent_business_id) {
    return businessEntity.parent_business?.business_setting?.in_app_payments ?? false
  }
  return true
}
